import util from '../helpers/util'
import type { Directive } from 'vue'

const LazyLoadDirective: Directive = {
    mounted: (el) => {
        if (el.nodeName.toUpperCase() === "IMG") {
            (el as HTMLImageElement).dataset.src = (el as HTMLImageElement).src;
            el.removeAttribute('src');
        }

        if (el.style.backgroundImage) {
            el.dataset.bg = el.style.backgroundImage;
            el.style.backgroundImage = '';
        }

        util.doSomethingOnceVisible(el, () => {
            if (el.dataset.src && el.nodeName.toUpperCase() === "IMG") {
                (el as HTMLImageElement).src = el.dataset.src;
            }

            if (el.dataset.bg) {
                el.style.backgroundImage = el.dataset.bg;
            }
        });
    }
};

export default LazyLoadDirective;